import {
	SET_POSTS_DATA,
	ADD_POST,
	DELETE_POST,
	ADD_TEXT_AREA,
	DELETE_TEXT_AREA,
	CLEAN_POSTS_DATA
} from '../../constants/postsData';
import moment from 'moment';
moment.locale('ru')

const initialState = [
	{
		domain: null,
		domain_name: '',
		textArea: [ '' ],
		post_date: moment().format('YYYY-MM-DD')
	}
];

const postsDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_POSTS_DATA:
			return state.map((post, i) => {
				return i === action.key ? action.payload : post;
			});
		case ADD_POST:
			return [ ...state, action.payload ];
		case DELETE_POST:
			return state.filter((post, i) => {
				return i !== action.key;
			});
		case ADD_TEXT_AREA:
			const newTextAreaArray = state[action.key].textArea;
			newTextAreaArray.push('');
			return state.map((post, i) => {
				return i === action.key ? { ...post, textArea: newTextAreaArray } : post;
			});
		case DELETE_TEXT_AREA:
			const newTextArray = state[action.key].textArea.slice(0, state[action.key].textArea.length - 1);
			return state.map((post, i) => {
				return i === action.key ? { ...post, textArea: newTextArray } : post;
			});
		case CLEAN_POSTS_DATA:
			return [
				{
					domain: null,
					domain_name: '',
					textArea: [ '' ],
					post_date: moment().format('YYYY-MM-DD')
				}
			];
		default:
			return state;
	}
};

export default postsDataReducer;
